import FormData from 'form-data';

function CustomFormData() {

}

CustomFormData.formUrlEncoded = function(params) {
    let encodedParams = [];
    // addItemsToForm(encodedParams, typeof params == 'object' ? [] : [options.name || 'model'], params);
    // addItemsToForm(encodedParams, typeof params == 'object' ? [] : [], params);
    addItemsToForm(encodedParams, [], params);
    return encodedParams.join('&');
};

CustomFormData.multipartFormData = function(params, files) {
    let formData = new FormData();

    for (let key in params) {
        // formData.append(key, params[key]);
        if (params[key] instanceof Array && params[key].length > 0) {
            params[key].forEach(param => {
                formData.append(key, param);
            });
        } else {
            formData.append(key, params[key]);
        }
    }

    for (let key in files) {
        // formData.append(key, files[key].value, files[key].fileName)
        let theFiles = [];
        if (files[key] instanceof Array && files[key].length > 0) {
            files[key].forEach(file => {
                theFiles.push(file);
            });
        }
        formData.append(key, (key == 'oldAttachment') ? JSON.stringify(theFiles) : files[key])
    }

    console.log('formData');
    console.log(formData);
    return formData;
};

CustomFormData.jsonString = function(params) {
    return JSON.stringify(params);
};

function addItemToForm(form, names, value) {
    var name = encodeURIComponent(names.join('.').replace(/\.\[/g, '['));
    value = encodeURIComponent(value.toString());
    form.push(`${name}=${value}`);
}

function addItemsToForm(form, names, obj) {
    if (obj === undefined || obj === "" || obj === null) return addItemToForm(form, names, "");

    if (
        typeof obj == "string"
        || typeof obj == "number"
        || obj === true
        || obj === false
        ) return addItemToForm(form, names, obj);

    if (obj instanceof Date) return addItemToForm(form, names, obj.toJSON());

    // array or otherwise array-like
    if (obj instanceof Array) {
        return obj.forEach((v, i) => {
            names.push(`[${i}]`);
            addItemsToForm(form, names, v);
            names.pop();
        });
    }

    if (typeof obj === "object") {
        return Object.keys(obj).forEach((k) => {
            names.push(k);
            addItemsToForm(form, names, obj[k]);
            names.pop();
        });
    }
}

export default CustomFormData;